module.exports = __webpack_public_path__ + "static/media/node-js.6ab692b6.svg";